<div class="main-content table-page ajustes-page detalle-version" [attr.aria-busy]="cargando">
  <div class="container-fluid">
    <nav class="app-migas" aria-label="Ruta de navegación">
      <a [routerLink]="rutaLista">Gestión de proyectos</a>
      <span class="material-icons app-migas__separador" aria-hidden="true">chevron_right</span>
      <a [routerLink]="rutaProyecto">{{ detalle?.proyecto?.nombre || "Proyecto" }}</a>
      <span class="material-icons app-migas__separador" aria-hidden="true">chevron_right</span>
      <a [routerLink]="rutaProyecto" [queryParams]="queryEtapa">{{ detalle?.etapa?.nombre || "Etapa" }}</a>
      <span class="material-icons app-migas__separador" aria-hidden="true">chevron_right</span>
      <span aria-current="page">{{ version?.nombre || "Versión" }}</span>
    </nav>

    <!-- Mientras llega o si falla: el estado vacío de table-page, como A1. -->
    <section class="table-page__card" *ngIf="(cargando && !detalle) || (!cargando && error)">
      <div class="table-page__empty">
        <span class="material-icons" aria-hidden="true">{{ error ? "layers_clear" : "hourglass_top" }}</span>
        <h1 class="detalle-version__estado">{{ error ? "No se pudo mostrar la versión" : "Consultando la versión" }}</h1>
        <span>{{ error || "Espere un momento." }}</span>
        <span class="detalle-version__acciones" *ngIf="error">
          <a class="app-form-btn app-form-btn--secondary app-form-btn--compact" [routerLink]="rutaProyecto" [queryParams]="queryEtapa">
            Ir al proyecto
          </a>
          <button type="button" class="app-form-btn app-form-btn--primary app-form-btn--compact" (click)="cargar()">Volver a intentar</button>
        </span>
      </div>
    </section>

    <ng-container *ngIf="detalle && version as v">
      <!-- Encabezado: nombre, estado, ambiente, quién la creó y las acciones. -->
      <section class="detalle-version__cabeza">
        <div class="detalle-version__identidad">
          <div class="detalle-version__nombre">
            <h1>{{ v.nombre || "Sin nombre" }}</h1>
            <span class="table-page__status-badge app-chip-icono" [ngClass]="chipVersion.clase">
              <span class="material-icons" aria-hidden="true">{{ chipVersion.icono }}</span>{{ chipVersion.texto }}
            </span>
            <span class="detalle-version__ambiente" *ngIf="v.ambiente">{{ v.ambiente }}</span>
          </div>
          <p>
            {{ creadaPor }}<ng-container *ngIf="cerradaDesde"> · Cerrada {{ cerradaDesde | lowercase }}</ng-container>
          </p>
        </div>
        <div class="detalle-version__acciones">
          <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact" *ngIf="detalle.puedeEditarVersion"
                  (click)="editarVersion()">
            <span class="material-icons" aria-hidden="true">edit</span>
            Editar versión
          </button>
          <button type="button" class="app-form-btn app-form-btn--primary app-form-btn--compact" *ngIf="detalle.puedeRegistrarPruebas"
                  (click)="registrarPruebas()">
            <span class="material-icons" aria-hidden="true">fact_check</span>
            Registrar pruebas
          </button>
        </div>
      </section>

      <!-- Datos de la versión e indicadores. -->
      <section class="ajustes-card detalle-version__card" aria-labelledby="a2-titulo-datos">
        <div class="ajustes-card__header">
          <h2 id="a2-titulo-datos" class="ajustes-card__title">
            <i class="material-icons" aria-hidden="true">layers</i>
            Datos de la versión
          </h2>
        </div>
        <div class="ajustes-card__body">
          <dl class="ajustes-data-grid detalle-version__datos">
            <div class="ajustes-data-item">
              <dt class="ajustes-data-item__label">Etapa</dt>
              <dd>
                <strong>{{ detalle.etapa?.nombre || "Sin nombre" }}</strong>
                <span class="detalle-version__sub">{{ fechasEtapa }}</span>
              </dd>
            </div>
            <div class="ajustes-data-item">
              <dt class="ajustes-data-item__label">Ambiente</dt>
              <dd><strong>{{ v.ambiente || sinDato }}</strong></dd>
            </div>
            <div class="ajustes-data-item">
              <dt class="ajustes-data-item__label">Ruta</dt>
              <dd><strong class="text-break-usuario">{{ v.ruta || "Sin ruta registrada" }}</strong></dd>
            </div>
            <div class="ajustes-data-item">
              <dt class="ajustes-data-item__label">Descripción</dt>
              <dd><strong class="text-break-usuario">{{ v.detalle || "Sin descripción" }}</strong></dd>
            </div>
          </dl>

          <div class="detalle-version__indicadores">
            <div class="app-dato-caja detalle-version__indicador">
              <span class="app-dato-caja__etiqueta">Casos ejecutados</span>
              <strong class="app-dato-caja__valor">{{ detalle.indicadores?.casosEjecutados ?? sinDato }}</strong>
              <span class="app-dato-caja__sub">{{ textoEjecuciones }}</span>
            </div>
            <div class="app-dato-caja detalle-version__indicador">
              <span class="app-dato-caja__etiqueta">
                <span class="detalle-version__punto is-aprobados" aria-hidden="true"></span>Aprobados
              </span>
              <strong class="app-dato-caja__valor">{{ detalle.indicadores?.casosAprobados ?? sinDato }}</strong>
              <span class="app-dato-caja__sub">{{ textoAprobados }}</span>
            </div>
            <div class="app-dato-caja detalle-version__indicador">
              <span class="app-dato-caja__etiqueta">
                <span class="detalle-version__punto is-fallidos" aria-hidden="true"></span>Fallidos
              </span>
              <strong class="app-dato-caja__valor">{{ detalle.indicadores?.casosFallidos ?? sinDato }}</strong>
              <span class="app-dato-caja__sub">{{ textoAprobados }}</span>
            </div>
            <div class="app-dato-caja detalle-version__indicador">
              <span class="app-dato-caja__etiqueta">Incidencias detectadas</span>
              <strong class="app-dato-caja__valor">{{ detalle.indicadores?.detectadas ?? 0 }}</strong>
              <span class="app-dato-caja__sub">{{ abiertasDetectadas }}</span>
            </div>
            <div class="app-dato-caja detalle-version__indicador">
              <span class="app-dato-caja__etiqueta">Resueltas en esta versión</span>
              <strong class="app-dato-caja__valor">{{ detalle.indicadores?.resueltasAqui ?? 0 }}</strong>
              <span class="app-dato-caja__sub">Su última resolución se entregó aquí</span>
            </div>
          </div>
        </div>
      </section>

      <!-- Ejecuciones de pruebas. -->
      <section class="table-page__card detalle-version__tabla" aria-labelledby="a2-titulo-ejecuciones">
        <div class="app-tabla-cabeza">
          <h2 id="a2-titulo-ejecuciones" class="app-tabla-cabeza__titulo">
            <span class="material-icons" aria-hidden="true">fact_check</span>
            Ejecuciones de pruebas
          </h2>
          <span class="app-contador"><span class="app-contador__etiqueta">Ejecuciones</span><strong class="app-contador__valor">{{ ejecuciones.length }}</strong></span>
        </div>

        <div class="table-page__table-wrap" *ngIf="ejecuciones.length; else sinEjecuciones">
          <table class="table-page__table">
            <caption class="cdk-visually-hidden">Ejecuciones de pruebas de la versión {{ v.nombre }}</caption>
            <thead>
              <tr>
                <th scope="col">Fecha</th>
                <th scope="col">Tipo / ciclo</th>
                <th scope="col">Ejecutó</th>
                <th scope="col">Casos</th>
                <th scope="col">Resultado</th>
                <th scope="col">Incidencias levantadas</th>
                <th scope="col">Evidencia</th>
                <th scope="col" *ngIf="detalle.puedeRegistrarPruebas"><span class="cdk-visually-hidden">Acciones</span></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let fila of ejecuciones; trackBy: trackEjecucion">
                <td class="detalle-version__fecha">{{ fila.fecha }}</td>
                <td><strong class="table-page__name">{{ fila.titulo }}</strong></td>
                <td>
                  <div class="table-page__cell-stack">
                    <span>{{ fila.ejecucion.nombreEjecuto || sinDato }}</span>
                    <span class="table-page__subtext" *ngIf="fila.ejecucion.rolEjecuto">{{ fila.ejecucion.rolEjecuto }}</span>
                  </div>
                </td>
                <td>
                  <div class="detalle-version__casos">
                    <span><strong>{{ fila.casos }}</strong> <span class="table-page__subtext">{{ fila.lineaCasos }}</span></span>
                    <span class="app-barra" aria-hidden="true" *ngIf="fila.porcentaje !== null">
                      <span [style.width.%]="fila.porcentaje"></span>
                    </span>
                  </div>
                </td>
                <td>
                  <span class="table-page__status-badge app-chip-icono" [ngClass]="fila.chip.clase">
                    <span class="material-icons" aria-hidden="true">{{ fila.chip.icono }}</span>{{ fila.chip.texto }}
                  </span>
                </td>
                <td class="detalle-version__numero">{{ fila.ejecucion.incidencias.length }}</td>
                <td>
                  <span class="table-page__subtext" *ngIf="!fila.evidencias.length">Sin evidencia</span>
                  <ul class="detalle-version__evidencias" *ngIf="fila.evidencias.length">
                    <li *ngFor="let archivo of fila.evidencias">
                      <button type="button" class="detalle-version__enlace" [attr.title]="'Ver ' + archivo.nombre"
                              (click)="verEvidencia(fila, archivo.evidencia)">
                        {{ fila.evidencias.length === 1 ? "Ver evidencia" : archivo.nombre }}
                      </button>
                    </li>
                  </ul>
                </td>
                <td class="detalle-version__accion" *ngIf="detalle.puedeRegistrarPruebas">
                  <button type="button" class="table-page__action-btn" title="Editar ejecución"
                          [attr.aria-label]="'Editar la ejecución ' + fila.titulo + ' del ' + fila.fecha" (click)="registrarPruebas(fila.ejecucion)">
                    <span class="material-icons" aria-hidden="true">edit</span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <ng-template #sinEjecuciones>
          <div class="table-page__empty">
            <span class="material-icons" aria-hidden="true">fact_check</span>
            <strong>Todavía no se registran pruebas en esta versión</strong>
            <span *ngIf="detalle.puedeRegistrarPruebas">Registra la primera con «Registrar pruebas».</span>
          </div>
        </ng-template>
      </section>

      <!-- Incidencias detectadas en la versión. -->
      <section class="table-page__card detalle-version__tabla" aria-labelledby="a2-titulo-detectadas">
        <div class="app-tabla-cabeza">
          <h2 id="a2-titulo-detectadas" class="app-tabla-cabeza__titulo">
            <span class="material-icons" aria-hidden="true">bug_report</span>
            Incidencias detectadas en {{ v.nombre || "esta versión" }}
          </h2>
          <span class="app-contador"><span class="app-contador__etiqueta">Abiertas</span><strong class="app-contador__valor">{{ detalle.indicadores?.detectadasAbiertas ?? 0 }}</strong></span>
        </div>

        <div class="table-page__table-wrap" *ngIf="detectadas.length; else sinDetectadas">
          <table class="table-page__table">
            <caption class="cdk-visually-hidden">Incidencias detectadas en la versión {{ v.nombre }}</caption>
            <thead>
              <tr>
                <th scope="col">Folio</th>
                <th scope="col">Título</th>
                <th scope="col">Prioridad</th>
                <th scope="col">Estatus</th>
                <th scope="col">Responsable</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let fila of detectadasVisibles; trackBy: trackIncidencia">
                <td>
                  <a class="table-page__link" [routerLink]="[detalleQA, fila.incidencia.idIncidencia]"
                     [attr.aria-label]="'Ver la incidencia ' + fila.folio">{{ fila.folio }}</a>
                </td>
                <td class="detalle-version__titulo-inc">{{ fila.incidencia.titulo || "Sin título" }}</td>
                <td><span class="app-prioridad" [ngClass]="fila.clasePrioridad">{{ fila.prioridad }}</span></td>
                <td><span class="app-chip-estatus" [ngClass]="fila.claseEstatus">{{ fila.incidencia.estatus || sinDato }}</span></td>
                <td>{{ fila.incidencia.responsable || "Sin responsable" }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <ng-container *ngIf="detectadas.length" [ngTemplateOutlet]="pieIncidencias"
                      [ngTemplateOutletContext]="{ total: detectadas.length, visibles: detectadasVisibles.length, todas: todasDetectadas, cual: 'detectadas' }">
        </ng-container>

        <ng-template #sinDetectadas>
          <div class="table-page__empty">
            <span class="material-icons" aria-hidden="true">bug_report</span>
            <strong>No se han detectado incidencias en esta versión</strong>
          </div>
        </ng-template>
      </section>

      <!-- Incidencias resueltas en la versión (su última resolución se entregó aquí, D2). -->
      <section class="table-page__card detalle-version__tabla" aria-labelledby="a2-titulo-resueltas">
        <div class="app-tabla-cabeza">
          <h2 id="a2-titulo-resueltas" class="app-tabla-cabeza__titulo">
            <span class="material-icons" aria-hidden="true">task_alt</span>
            Incidencias resueltas en esta versión
          </h2>
          <span class="app-contador"><span class="app-contador__etiqueta">Resueltas</span><strong class="app-contador__valor">{{ resueltas.length }}</strong></span>
        </div>

        <div class="table-page__table-wrap" *ngIf="resueltas.length; else sinResueltas">
          <table class="table-page__table">
            <caption class="cdk-visually-hidden">Incidencias resueltas en la versión {{ v.nombre }}</caption>
            <thead>
              <tr>
                <th scope="col">Folio</th>
                <th scope="col">Título</th>
                <th scope="col">Detectada en</th>
                <th scope="col">Resuelta por</th>
                <th scope="col">Fecha</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let fila of resueltasVisibles; trackBy: trackIncidencia">
                <td>
                  <a class="table-page__link" [routerLink]="[detalleQA, fila.incidencia.idIncidencia]"
                     [attr.aria-label]="'Ver la incidencia ' + fila.folio">{{ fila.folio }}</a>
                </td>
                <td class="detalle-version__titulo-inc">{{ fila.incidencia.titulo || "Sin título" }}</td>
                <td><strong class="detalle-version__version">{{ fila.detectadaEn }}</strong></td>
                <td>{{ fila.incidencia.resolvio || sinDato }}</td>
                <td class="detalle-version__fecha">{{ fila.fechaResolucion }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <ng-container *ngIf="resueltas.length" [ngTemplateOutlet]="pieIncidencias"
                      [ngTemplateOutletContext]="{ total: resueltas.length, visibles: resueltasVisibles.length, todas: todasResueltas, cual: 'resueltas' }">
        </ng-container>

        <ng-template #sinResueltas>
          <div class="table-page__empty">
            <span class="material-icons" aria-hidden="true">task_alt</span>
            <strong>Ninguna resolución se ha entregado en esta versión</strong>
          </div>
        </ng-template>
      </section>
    </ng-container>

    <!-- «Mostrando 5 de 14 incidencias · Ver las 14» de las dos tablas de incidencias. -->
    <ng-template #pieIncidencias let-total="total" let-visibles="visibles" let-todas="todas" let-cual="cual">
      <div class="table-page__footer detalle-version__pie">
        <span>{{ mostrando(visibles, total) }}</span>
        <button type="button" class="detalle-version__enlace" *ngIf="total > visibles || todas" [attr.aria-expanded]="todas"
                (click)="alternarTodas(cual)">
          {{ todas ? "Ver menos" : "Ver las " + total }}
        </button>
      </div>
    </ng-template>
  </div>
</div>
